import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getColorOptions,
  getFontPickerOptions,
  getFontSizeOptions,
  getFontStyleOptions,
  getFontWeightOptions,
  getLineHeightOptions,
  getTextAlignOptions,
  getTextDecorationOptions,
  getTextTransformOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "h4",
  props: {
    text: {
      prop: "other",
      type: "string",
      value: "H4 text",
    },
    headingLevel: {
      prop: "other",
      type: "heading-level-picker",
      value: "h4",
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        color: getColorOptions(defaultStyles.color),
        textTransform: getTextTransformOptions(defaultStyles.textTransform),
        fontStyle: getFontStyleOptions(defaultStyles.fontStyle),
        fontWeight: getFontWeightOptions(defaultStyles.fontWeight),
        fontSize: getFontSizeOptions(defaultStyles.fontSize),
        fontFamily: getFontPickerOptions(defaultStyles.fontFamily),
        lineHeight: getLineHeightOptions(defaultStyles.lineHeight),
        textAlign: getTextAlignOptions(defaultStyles.textAlign),
        textDecoration: getTextDecorationOptions(defaultStyles.textDecoration),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
      },
    },
  },
};
